import { InputAdornment, TextField } from "@material-ui/core";
import { ModalV2 } from "components/Modal/ModalV2";
import { useForm } from "hooks/useForm";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { sendConfigUnitV2 } from "redux/actions/unitsSection/unitsAction";
import DiscountIcon from "@mui/icons-material/Discount";
import { blue } from "@mui/material/colors";

import { formatNumber } from "helpers/getNumberFormats";

export const UpdateDiscountForm = ({ open, setOpen, unit }) => {
  const { isLoadingComp } = useSelector(({ search }) => search);
  const dispatch = useDispatch();

  const initialDiscount = unit.conf?.discount || 0;
  const { onChangeNumberV2, values, setValues } = useForm({
    discount: initialDiscount,
    discount_: formatNumber({ input: initialDiscount }),
  });

  const handleFocus = () => {
    const raw = parseFloat(values.discount);
    if (raw === 0 || isNaN(raw)) {
      setValues({ discount: "", discount_: "" });
    }
  };

  const handleBlur = () => {
    const raw = parseFloat(values.discount);
    if (isNaN(raw) || values.discount === "") {
      setValues({ discount: 0, discount_: formatNumber({ input: 0 }) });
    }
  };

  const handlePercentage = () => {
    dispatch(
      sendConfigUnitV2(
        unit.id,
        { id: unit.id, conf: { discount: values.discount } },
        false,
        false,
        "",
        setOpen,
      ),
    );
  };

  return (
    <ModalV2
      title="Actualizar descuento por litro"
      open={open}
      onClose={setOpen}
      onSubmit={handlePercentage}
      justConfirm
      isLoading={isLoadingComp?.loadingConfigEdit}
      confirmColor="warning"
    >
      <TextField
        label="Descuento por litro"
        name="discount"
        value={values?.discount_}
        onChange={(e) => onChangeNumberV2(e, { decimals: 2, maxDigits: 8 })}
        onFocus={handleFocus}
        onBlur={handleBlur}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <DiscountIcon style={{ color: blue[500], marginLeft: 10 }} />
            </InputAdornment>
          ),
        }}
        fullWidth
        variant="outlined"
        inputProps={{
          style: {
            textAlign: "right",
          },
        }}
      />
    </ModalV2>
  );
};
